'use client';

import { FC, PropsWithChildren } from 'react';
import { motion } from 'modules/framer-motion';
import { getFadeAnimation } from 'modules/framer-motion/presets';

export const AppearanceAnimationBlock: FC<
  PropsWithChildren<{ keyVal: string; className?: string; el?: 'div' | 'li' }>
> = ({ children, keyVal, className, el = 'div' }) => {
  const Component = motion[el];
  const headerHeight = 60;

  const animation = getFadeAnimation();

  animation.initial.y = -headerHeight;
  animation.animate.y = 0;

  return (
    <Component {...animation} key={keyVal} className={className}>
      {children}
    </Component>
  );
};
